import React, { ChangeEvent, CSSProperties, useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import {
  ParentDataType,
  PayloadCreateDataType,
  PayloadEditDataType,
} from '../../containers/ProfileParentsPage/types'
import moment from 'moment'

// Styles
import './styles.scss'

// Icons
import IconEdit from '../AvatarParentBlock/images/iconEdit'
import IconSave from './images/iconSave'
import IconCancel from './images/iconCancel'

export default ({
  title,
  style,
  colorEditIcon,
  colorInput,
  gender,
  parentData,
  onCreate,
  onSave,
}: {
  title: string
  style?: CSSProperties
  colorEditIcon: string
  colorInput: string
  gender: 'male' | 'female'
  parentData: ParentDataType
  onCreate: (data: PayloadCreateDataType) => void
  onSave: (data: PayloadEditDataType) => void
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [name, setName] = useState<string>('')
  const [middleName, setMiddleName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [isOpenCalendar, setIsOpenCalendar] = useState<boolean>(false)
  const [birthday, setBirthday] = useState<Date | null>(null)

  useEffect(() => {
    if (parentData) {
      setName(parentData.first_name || '')
      setMiddleName(parentData.middle_name || '')
      setLastName(parentData.last_name || '')
      setBirthday(
        parentData.birthdate ? moment(parentData.birthdate).toDate() : null
      )
    }
  }, [parentData])

  const onChangeLastName = (event: ChangeEvent<HTMLInputElement>) => {
    setLastName(event.currentTarget.value)
  }

  const onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.currentTarget.value)
  }

  const onChangeMiddleName = (event: ChangeEvent<HTMLInputElement>) => {
    setMiddleName(event.currentTarget.value)
  }

  return (
    <div className={'personal-parent-block'} style={style}>
      <div className={'header'}>
        <div className={'header__title'}>{title}</div>
        <div className={'header__nav'}>
          {isEdit ? (
            <>
              <IconSave
                onClick={() => {
                  if (parentData) {
                    onSave({
                      parent_id: parentData.profile_id,
                      first_name: name,
                      middle_name: middleName,
                      last_name: lastName,
                      gender,
                      birthdate: birthday
                        ? moment(birthday).format('YYYY-MM-DD')
                        : '',
                    })
                  } else {
                    onCreate({
                      first_name: name,
                      middle_name: middleName,
                      last_name: lastName,
                      gender,
                      birthdate: birthday
                        ? moment(birthday).format('YYYY-MM-DD')
                        : '',
                    })
                  }
                  setIsEdit(false)
                }}
                className={'header__nav-button'}
                style={{ marginRight: 9 }}
              />
              <IconCancel
                className={'header__nav-button'}
                onClick={() => {
                  setIsEdit(false)
                  // initialDefaultValues()
                }}
              />
            </>
          ) : (
            <IconEdit
              className={'header__nav-button'}
              color={colorEditIcon}
              onClick={() => setIsEdit(true)}
            />
          )}
        </div>
      </div>
      <div className={'personal-edit-block__column'}>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Фамилия:</div>
          <input
            value={lastName}
            disabled={!isEdit}
            style={!isEdit ? { background: colorInput } : {}}
            onChange={onChangeLastName}
          />
        </div>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Имя:</div>
          <input
            value={name}
            disabled={!isEdit}
            style={!isEdit ? { background: colorInput } : {}}
            onChange={onChangeName}
          />
        </div>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Отчество:</div>
          <input
            value={middleName}
            disabled={!isEdit}
            style={!isEdit ? { background: colorInput } : {}}
            onChange={onChangeMiddleName}
          />
        </div>
        <div className={'personal-edit-block__column-additional'}>
          <div className={'birthday'}>
            <div className={'label'}>
              Дата
              <br />
              рождения:
            </div>
            <div
              className={
                isOpenCalendar ? 'birthday__date open' : 'birthday__date'
              }
            >
              <DatePicker
                selected={birthday}
                onChange={(date: Date) => setBirthday(date)}
                locale={'ru'}
                dateFormat={'P'}
                onCalendarOpen={() => setIsOpenCalendar(true)}
                onCalendarClose={() => setIsOpenCalendar(false)}
                disabled={!isEdit}
                popperPlacement={'bottom'}
                popperProps={{
                  placement: 'bottom',
                  modifiers: [
                    {
                      name: 'flip',
                      options: {
                        enabled: false,
                        fallbackPlacements: ['bottom'],
                      },
                    },
                  ],
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
